import { useMutation, useQueryClient } from '@tanstack/react-query';
import { holdPcmpProposal, releasePcmpProposal } from '../api/pcmpProposals.api';
import type { PcmpHoldResult } from '../types/pcmpProposal.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export type PcmpHoldAction = 'HOLD' | 'RELEASE';

/** Hold or release one proposal; the text is the hold reason or the release comment. */
export function useHoldPcmpProposal(
  proposalId: number,
  action: PcmpHoldAction,
  onSuccess: () => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (text: string) =>
      action === 'HOLD'
        ? holdPcmpProposal(proposalId, { reason: text })
        : releasePcmpProposal(proposalId, { comment: text }),
    ...pcmpActionCallbacks<PcmpHoldResult>(
      queryClient,
      (result) =>
        action === 'HOLD' ? `Put on hold at ${result.stageLabel}` : 'Released from hold',
      onSuccess,
    ),
  });
}
